import PropTypes from 'prop-types';
import React from 'react';
import { Common } from 'ws-scripts/modules/common';
import PhotoSwipeGallery from './PhotoSwipeGallery';
import CommonLink from './CommonLink';

class PhotoSwipeGalleryButton extends React.Component {
	render() {
		const {
			images,
			modalSettings,
			videos,
			videoOrder,
			/* render settings */
			currentIndex,
			innerWidth,
			innerHeight,

			widgetInfo,
			onCurrentIndexChange,
			updateModalSettings,

			// prefs for colors
			galleryBackgroundColor,
			galleryIconColor,

			trackGa
		} = this.props;

		// to fix an empty gallery showing up with 1 of 0 images
		const currentIndexPlusOne = images.length > 0 ? currentIndex + 1 : 0;

		return (
			<Common
				render={({ labels }) => {
					return (
						<div>
							<div
								className={`${galleryBackgroundColor} btn-border-radius-base p-3 d-flex align-items-center justify-content-center`}
							>
								<CommonLink
									linkName={`${currentIndexPlusOne} ${labels.get(
										'OF'
									)} ${images.length} ${labels.get(
										'PHOTOS'
									)}`}
									galleryIconColor={galleryIconColor}
									iconClass="ddc-icon-images"
									onClick={() => {
										updateModalSettings({
											modalIsOpen: true,
											videoIsOpen: false,
											spin360IsOpen: false
										});
										trackGa({
											element: 'Photo Count Button',
											elementCta: 'Photo Count',
											result: 'Opens gallery modal'
										});
									}}
								/>

								{videoOrder && videoOrder.length > 0 ? (
									<CommonLink
										linkName={labels.get('VIDEO')}
										galleryIconColor={galleryIconColor}
										iconClass="ddc-icon-play2"
										onClick={() => {
											updateModalSettings({
												modalIsOpen: true,
												videoIsOpen: true,
												spin360IsOpen: false
											});
											trackGa({
												element: 'Video Button',
												elementCta: 'Video',
												result: 'Opens video'
											});
										}}
									/>
								) : null}

								{widgetInfo.vehicle.fyuseUid &&
								widgetInfo.vehicle.fyuseUid.length > 0 ? (
									<Common
										render={({ flags }) => {
											if (
												flags[
													'ws-vehicle-media-homenet'
												]
											) {
												return (
													<CommonLink
														linkName="360"
														galleryIconColor={
															galleryIconColor
														}
														iconClass="ddc-icon-360-spin"
														onClick={() => {
															updateModalSettings(
																{
																	modalIsOpen: true,
																	videoIsOpen: false,
																	spin360IsOpen: true
																}
															);
															trackGa({
																element:
																	'Homenet 360 Button',
																elementCta:
																	'Homenet',
																result:
																	'Opens Homenet 360 spin'
															});
														}}
													/>
												);
											} else {
												return null;
											}
										}}
									/>
								) : null}
							</div>
							<PhotoSwipeGallery
								isOpen={modalSettings.modalIsOpen}
								onClose={() => {
									updateModalSettings({
										currentIndex: null,
										modalIsOpen: false,
										videoIsOpen: false,
										spin360IsOpen: false
									});
								}}
								currentIndex={currentIndex}
								afterChange={gallery => {
									const pSwipe = gallery.photoSwipe;
									if (pSwipe && pSwipe.getCurrentIndex) {
										const index = pSwipe.getCurrentIndex();
										if (modalSettings.persistIndex) {
											onCurrentIndexChange(index);
										}
										updateModalSettings({
											currentIndex: index
										});
									}
								}}
								viewportWidth={Math.round(innerWidth)}
								viewportHeight={Math.round(innerHeight)}
								updateModalSettings={updateModalSettings}
								widgetInfo={widgetInfo}
								trackGa={trackGa}
								modalSettings={modalSettings}
								images={images}
								video={
									videoOrder.length > 0
										? videos[videoOrder[0]]
										: null
								} // In the event there are multiple videos, take the first one
								labels={labels}
							/>
						</div>
					);
				}}
			/>
		);
	}
}

PhotoSwipeGalleryButton.propTypes = {
	onCurrentIndexChange: PropTypes.func.isRequired,
	images: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.number,
			src: PropTypes.string,
			thumbnail: PropTypes.string
		})
	).isRequired,
	videos: PropTypes.shape({}),
	videoOrder: PropTypes.arrayOf(
		PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	).isRequired,
	modalSettings: PropTypes.shape({
		zoomedIn: PropTypes.bool,
		fullScreen: PropTypes.bool,
		modalIsOpen: PropTypes.bool
	}).isRequired,

	// renderSettings
	innerWidth: PropTypes.number.isRequired,
	innerHeight: PropTypes.number.isRequired,
	currentIndex: PropTypes.number.isRequired,

	updateModalSettings: PropTypes.func.isRequired,
	trackGa: PropTypes.func.isRequired,

	// prefs for colors
	galleryBackgroundColor: PropTypes.string,
	galleryIconColor: PropTypes.string,

	widgetInfo: PropTypes.shape({
		deviceType: PropTypes.string,
		vehicle: PropTypes.shape({
			fyuseUid: PropTypes.string
		}).isRequired
	}).isRequired
};

PhotoSwipeGalleryButton.defaultProps = {
	videos: null,
	galleryBackgroundColor: 'bg-white',
	galleryIconColor: 'text-primary'
};

export default PhotoSwipeGalleryButton;



// WEBPACK FOOTER //
// ./src/components/photoswipe/PhotoSwipeGalleryButton.jsx